export const UserRoleTypes = {
  DataEntry: 101,
  Supervisor: 102,
  Vendor: 201,
  Admin: 901,
  SuperAdmin: 999,
}